// Buyer-facing "social proof" badge picker with a graceful fallback
// designed for a STARTER marketplace where most items have zero purchases.
//
// Tiered priority (first non-null wins — buyer always sees momentum or nothing):
//   1.  🔥 N sold in last 30 days        when sold_count_30d >= 10
//   2.  👁 N viewing this week            when view_count_7d  >= 20
//   3.  ✨ New arrival                    when created_at < 14 days ago
//   4.  null  (don't render anything — never show "0 sold")
//
// Crucially we NEVER expose a tiny number ("1 sold", "3 viewed") which would
// signal a dead store. Below threshold, we either fall through to a softer
// signal or render nothing at all.

const SOLD_THRESHOLD = 10;
const VIEW_THRESHOLD = 20;
const NEW_DAYS = 14;

const isRecent = (iso) => {
  if (!iso) return false;
  try {
    const created = new Date(iso);
    const days = (Date.now() - created.getTime()) / (1000 * 60 * 60 * 24);
    return days >= 0 && days < NEW_DAYS;
  } catch {
    return false;
  }
};

/**
 * @param {object} listing  Listing dict from the API
 * @returns {{ kind:'sold'|'views'|'new', label:string, icon:string } | null}
 */
export function socialProofBadge(listing) {
  if (!listing) return null;
  const sold = Number(listing.sold_count_30d) || 0;
  const views = Number(listing.view_count_7d) || 0;
  if (sold >= SOLD_THRESHOLD) {
    return { kind: "sold", icon: "flame", label: `${sold} sold in last 30 days` };
  }
  if (views >= VIEW_THRESHOLD) {
    return { kind: "views", icon: "eye", label: `${views} viewing this week` };
  }
  if (isRecent(listing.created_at)) {
    return { kind: "new", icon: "sparkles", label: "New arrival" };
  }
  return null;
}
